<template>
  <section>
    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <el-table
      :data="list"
      v-loading="listLoading"
      style="width: 100%"
      ref="table"
      class="custom-tbl"
    >
      <el-table-column label="序号" type="index" width="80"></el-table-column>
      <el-table-column label="场地名称" prop="Name"></el-table-column>
      <!-- <el-table-column label="价格" prop="Price"></el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" class="delBtn" @click="handleDel(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="page.currentPage"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="page.pageSize"
        :total="total"
        style="float: right"
      >
      </el-pagination>
    </el-col>
    <!--表单弹窗-->
    <el-dialog
      :title="dialogStatus === 'add' ? '新增' : '修改'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <el-form :model="form" label-width="120px" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="24">
            <el-form-item label="场地名称" prop="Name">
              <el-input v-model="form.Name" auto-complete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="价格" prop="Price">
              <el-input-number
                :min="0"
                :step="0.01"
                v-model="addForm.Price"
              ></el-input-number>
            </el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="dialogVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="submitForm"
          :loading="submitLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </section>
</template>
<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import {
  getSiteList,
  addSite,
  deleteSite,
  editSite,
  getSiteDetail,
} from "@/api/stadium/stadium";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      filters: {},
      buttonList: [],
      list: [],
      total: 0,
      listLoading: false,
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      dialogVisible: false, // 弹窗显示状态
      dialogStatus: "add", // 弹窗状态：add-新增，edit-编辑
      submitLoading: false,
      formRules: {},
      form: {}, // 表单数据
    };
  },
  methods: {
    handleEdit(row) {
      getSiteDetail({ Id: row.Id }).then((res) => {
        if (res.data.success) {
          this.form = res.data.response;
          this.dialogStatus = "edit";
          this.dialogVisible = true;
        }
      });
    },

    handleDel(row) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      }).then(() => {
        deleteSite({
          Id: row.Id,
        }).then((res) => {
          if (res.data.success) {
            this.initPage();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
          this.getList();
        });
      });
    },

    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true;
          let para = Object.assign({}, this.form);
          para.VenueId = this.$route.query.Id;
          para.VenueCourtId = this.$route.query.cId;

          const submitAction = this.dialogStatus === "add" ? addSite : editSite;

          submitAction(para)
            .then((res) => {
              if (util.isEmt.format(res)) {
                this.submitLoading = false;
                return;
              }

              if (res.data.success) {
                this.submitLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["form"].resetFields();
                this.dialogVisible = false;
                this.initPage();
                this.getList();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.submitLoading = false;
            });
        }
      });
    },

    handleBack() {
      this.$router.go(-1);
    },

    handleAdd() {
      this.dialogVisible = true;
      this.dialogStatus = "add";
      this.form = {};
    },

    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },

    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },

    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList();
    },

    initPage() {
      this.page.currentPage = 1;
      this.page.pageSize = 10;
      this.filters = {
        name: "",
      };
    },

    getList() {
      if (!this.$route.query.Id) {
        this.$message.error("请先选择场馆");
        this.$router.back();
        return;
      }
      let para = {
        page: this.page.currentPage,
        intPageSize: this.page.pageSize,
        key: this.filters.name,
        Id: this.$route.query.cId,
      };
      this.listLoading = true;

      getSiteList(para)
        .then((res) => {
          this.total = res.data.response.dataCount;
          this.list = res.data.response.data;
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
  },
  created() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.getList();
  },
};
</script>
<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}
.delBtn {
  color: #db3636;
}
</style>
